import React, { useEffect, useRef, useState } from "react";

import { CallPopUpAgentActions } from "../../../../store/slices/voice_call_slice/call_popup_agent";
import { CallService } from "../../../../services/call_service";
import { ChatState } from "../../../../base/models/model";
// import { Cookie } from "../../../../base/utils";
import { GetItemFromStorage } from "../../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../../custom_hooks/localStorageKeys";
import ReactPhoneInput from "react-phone-input-2";
import { Select, notification } from "antd";
import { SetItemInStorage } from "../../../../custom_hooks/useStorage";
import { WtButton } from "../../Button/button";
import _ from "lodash";
// import callChatService from "../../../../base/service/chatService";
// import { callSDK } from "unifiedring-sdk";
// import flag from "../../../../styles/images/flag.png";
import { getContactDetailsWhilegettingCall, getContactDetails, getQueueeList, getDndByCustomerNum } from "../../../../store/api/helperspi/contactListapiService";
// import { getUser } from "../../../../constants/base/utils";
import styles from "./dialpadnumber.module.scss";
import { useDispatcher } from "../../../../custom_hooks/use_app_dispatch";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { spawn } from "child_process";
import "react-phone-input-2/lib/style.css";
// import { v4 as uuidv4 } from "uuid";

export default function DialpadnumberNew() {
  const { Option } = Select;
  const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);
  const contactList: any = useSelector((state: any) => state.contactListForAgent);
  const userList: any = useSelector((state: any) => state.agentTracker);
  let { agentList } = userList;
  const { isQueueList, AllQueueList, filterQueueList } = contactList;
  const dialPadDetails: any = useSelector((state: any) => state.callPopUpDetails);
  let { dialedNumber, queueDetails, queueName, isCalling, callDetails } = dialPadDetails;
  const LoginCcaasUserDetails: any = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
  let { users } = useSelector((state: any) => state.userList);
  const dispatch = useDispatcher();
  const navigate = useNavigate();
  const { makeCallFunctionForAll } = CallService(dispatch, navigate);
  const [error, setError] = useState({
    number: false,
    queue: false
  });
  const [disable,setDisable,]=useState(false)
  const backSpace = () => {
    if (dialedNumber?.length !== 0) {
      dispatch(CallPopUpAgentActions.backSpace());
    }
  };
  useEffect(() => {
    if(!isQueueList){
      dispatch(getQueueeList());

    }
  }, [dispatch]);


  document.addEventListener("longpress", function (e) { });

  const countryCode = GetItemFromStorage(LocalStorage.COUNTRY_CODE) ?? "gb";
  const countryCodeNo = GetItemFromStorage(LocalStorage.COUNTRY_CODE_NO) ?? "44";
  useEffect(() => {
    if (countryCodeNo && !dialedNumber) {
      dispatch(CallPopUpAgentActions.setDialPadNumber(countryCodeNo));
    }
  }, [])
  const agentWithBound_call = [] as any;
  const agentWithoutBound_call = [] as any
  users.forEach((user: { callTypeId: any }) => {
    if (user.callTypeId) {
      agentWithBound_call.push(user);
    }
    else {
      agentWithoutBound_call.push(user);
    }
    ;

  });
  const onKeyPress = (number: any) => {
    setDisable(false)
    setError({
      ...error,
      number: false
    });
    if (['*', '#'].includes(number)) {
      return
    }
    if (number === "") {
      dispatch(CallPopUpAgentActions.removeDialPadNumber());
    } else if (dialedNumber?.length < 15) {
      dispatch(CallPopUpAgentActions.setDialPadNumber(number));
    }
  };

  let timer: any = null;
  let plus = 0;

  const onmousedownfunc = (e: any) => {
    if (e.button === 0) {
      const longpressfunc = () => {
        setTimeout(() => {
          plus = 1;
        }, 600);
      };
      timer = longpressfunc();
    }
  };

  const onKeyUpPressed = () => {
    clearTimeout(timer);
    if (plus === 1) {
      dispatch(CallPopUpAgentActions.setDialPadOnKeyPressUP("+"));
    } else {
      dispatch(CallPopUpAgentActions.setDialPadOnKeyPressUP("0"));
    }
    plus = 0;
  };

  const onKeyboardPress = (number: any) => {
    // console.log(number, "keyboard");
    if (dialedNumber?.length < 15) {
      dispatch(CallPopUpAgentActions.setNumber(number));
    }
  };

  // const getContactDetail = async () => {
  //   if (dialedNumber.length >= 7 && Object.keys(queueDetails).length !== 0) {
  //     let contactDetails: any;
  //     console.log(dialedNumber, "dialedNumber");
  //     let data: any = document.getElementById("CallBtn");
  //     data.disabled = true;
  //     await getContactDetails(dialedNumber, 'Call').then(async (res: any) => {
  //       if (res?.data?.statusCode === 200) {
  //         contactDetails = res?.data?.getContactNumberRes[0];
  //       } else {
  //         contactDetails.calledPersonDetails = {};
  //       }
  //       data.disabled = false;
  //       await makeCall(contactDetails);
  //     });
  //   }
  //   else if (dialedNumber.length <= 7 && Object.keys(queueDetails).length == 0) {
  //     setError({...error,number: true,queue: true});
  //   }
  //   else if (Object.keys(queueDetails).length !== 0) {
  //     // dispatch(CallPopUpAgentActions.closeTransfer())
  //     setError({
  //       ...error,
  //       number: true
  //     });
  //   }
  //   else {
  //     setError({...error,number: true});
  //     setError({...error,queue: true});
  //   }
  // };
  const getContactDetail = async () => {
    // console.log("queueDetails", queueDetails);
    setDisable(true)
    if (callDetails?.length === 0) {
      if (dialedNumber.length >= 7 && Object.keys(queueDetails).length !== 0) {
        let resp: any = await getDndByCustomerNum(dialedNumber)
        let data = resp.data.result?.[0]?.doNotDisturb ?? 0
        if (data) {
          notification.info({
            message: `This contact is marked as Do Not Disturb. You are not permitted to make a call.`,
            placement: "topRight",
            className: "toastNotification error",
            icon: <span className="icon__Error24" />,
            closeIcon: <span className="icon__IconCloseNew16" />,
            duration: 3,
            top: 70,

          });
          setDisable(false)
        } else {
          let contactDetails : any = {};
          // console.log(dialedNumber, "dialedNumber");
          let data: any = document.getElementById("CallBtn");
          data.disabled = true;
  
          await getContactDetails(dialedNumber, 'Call').then(async (res: any) => {
            setDisable(false)
            if (res?.data?.statusCode === 200) {
              contactDetails = res?.data?.getContactNumberRes?.[0] ?? {};
            } else {
              contactDetails.calledPersonDetails = {};
            }
            data.disabled = false;
            await makeCall(contactDetails);
          });
        }
      
     
      }
      else if (dialedNumber.length >= 7 && Object.keys(queueDetails).length === 0) {
        setError({ ...error, queue: true });
        setDisable(false)
      }
      else if (dialedNumber.length <= 7 && Object.keys(queueDetails).length !== 0) {
        // dispatch(CallPopUpAgentActions.closeTransfer())
        setError({ ...error, number: true });
        setDisable(false)
      }
      else {
        setError({ ...error, number: true, queue: true });
        setDisable(false)
      }
    } else {
      if (dialedNumber.length >= 7) {
        let contactDetails: any;
        // console.log(dialedNumber, "dialedNumber");
        let data: any = document.getElementById("CallBtn");
        data.disabled = true;

        await getContactDetails(dialedNumber, 'Call').then(async (res: any) => {
          setDisable(false)
          if (res?.data?.statusCode === 200) {
            contactDetails = res?.data?.getContactNumberRes[0];
          } else {
            contactDetails.calledPersonDetails = {};
          }
          data.disabled = false;
          await makeCall(contactDetails);
        });
      }
      else {
        setError({ ...error, number: true, queue: false });
        setDisable(false)

      }
    }
  };


  const noOutbound = () => {
    dispatch(CallPopUpAgentActions.closeTransfer())
    dispatch(CallPopUpAgentActions.setNumber(''));
    notification.info({
      message: `Outbound calls are disabled for your profile. Unable to initiate the call.`,
      placement: "topRight",
      className: "toastNotification error",
      icon: <span className="icon__Error24" />,
      closeIcon: <span className="icon__IconCloseNew16" />,
      duration: 3,
      top: 70,

    });
  }

  const makeCall = (contactDetails: any) => {
    dispatch(CallPopUpAgentActions.updateTransferType({ transfer_type: "EXTERNAL" }));
    makeCallFunctionForAll(dialedNumber, 2, contactDetails);
  };

  const updatecountryInSessionData = (country: any) => {
    // console.log(countryCode, country?.countryCode)
    if (countryCode !== country?.countryCode) {
      SetItemInStorage(LocalStorage.COUNTRY_CODE, country?.countryCode);
      SetItemInStorage(LocalStorage.COUNTRY_CODE_NO, country?.dialCode);
    }
  };

  useEffect(() => {

  }, [contactList, dialPadDetails]);
  return (
    <>
      <div className={`countryinput dialpadinput ${styles.dialtop}`}>
        <ReactPhoneInput
          inputProps={{
            name: "phone",
            required: true,
            autoFocus: true,
            enableClickOutside: false,
          }}
          containerClass="topbarCallInput"
          inputClass="cusInputFlag"
          country={countryCode}
          placeholder="Enter Phone number"
          enableLongNumbers={15}
          value={dialedNumber?.toString()}
          onChange={(e: any, d: any) => {
            updatecountryInSessionData(d);
            onKeyboardPress(e);
          }}
        // defaultCountry={"sg"}
        // value={transfer.externalNumber}
        // onChange={setExternalExtensionValue}
        />
        {/* <div className={styles.chatBackspace} onClick={backSpace}>
          <div className="icon__BackSpace24"></div>
        </div> */}
        {/* <span className="icon__placeholdericon16 clearicon" onClick={backSpace}></span> */}
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14" fill="none" onClick={backSpace}>
          <path d="M15.3721 0.759766H5.5025C4.921 0.759766 4.3785 1.05197 4.059 1.53787L1.265 5.78517C1.0216 6.15357 0.899603 6.57937 0.899903 7.00317C0.899703 7.42747 1.0222 7.85327 1.2656 8.22287L4.0592 12.4634C4.3788 12.9488 4.921 13.2407 5.5021 13.2407H15.3721C16.3266 13.2405 17.0995 12.4675 17.0999 11.5132V2.48757C17.0995 1.53277 16.3265 0.760066 15.3721 0.759766ZM13.1917 8.80887C13.4847 9.10187 13.4847 9.57647 13.1917 9.86937C13.0452 10.0159 12.8533 10.0891 12.6614 10.0891C12.4695 10.0891 12.2776 10.0159 12.1311 9.86937L10.3225 8.06077L8.5139 9.86937C8.3674 10.0159 8.1755 10.0891 7.9836 10.0891C7.7917 10.0891 7.5998 10.0159 7.4533 9.86937C7.1603 9.57637 7.1603 9.10177 7.4533 8.80887L9.2619 7.00027L7.4533 5.19167C7.1603 4.89866 7.1603 4.42407 7.4533 4.13117C7.7463 3.83827 8.2209 3.83817 8.5138 4.13117L10.3224 5.93977L12.131 4.13117C12.424 3.83817 12.8986 3.83817 13.1915 4.13117C13.4844 4.42417 13.4845 4.89877 13.1915 5.19167L11.3829 7.00027L13.1917 8.80887Z" fill="#BDBEBF" />
        </svg>
      </div>
      {error?.number ? <span className={`${styles.invadidspancont} invalidspan`} >Invalid Contact Number</span> : <span className={styles.invadidspancont}></span>}
      <div className={`scroller ${styles.dialscreens}`}>
        <div className={`${styles.chatDialPadInner} dialnumcon`}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold} dialnum`} onClick={() => onKeyPress("1")}>
            <span className="">1</span>
            <div className={styles.tooltips}></div>
          </div>
        </div>
        <div className={`${styles.chatDialPadInner} dialnumcon`}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold} dialnum`} onClick={() => onKeyPress("2")}>
            <span className="">2</span>
            <div className={styles.tooltips}>ABC</div>
          </div>
        </div>
        <div className={`${styles.chatDialPadInner} dialnumcon`}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold} dialnum`} onClick={() => onKeyPress("3")}>
            <span className="">3</span>
            <div className={styles.tooltips}>DEF</div>
          </div>
        </div>
        <div className={`${styles.chatDialPadInner} dialnumcon`}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold} dialnum`} onClick={() => onKeyPress("4")}>
            <span className="">4</span>
            <div className={styles.tooltips}>GHI</div>
          </div>
        </div>
        <div className={`${styles.chatDialPadInner} dialnumcon`}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold} dialnum`} onClick={() => onKeyPress("5")}>
            <span className="">5</span>
            <div className={styles.tooltips}>JKL</div>
          </div>
        </div>
        <div className={`${styles.chatDialPadInner} dialnumcon`}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold} dialnum`} onClick={() => onKeyPress("6")}>
            <span className="">6</span>
            <div className={styles.tooltips}>MNO</div>
          </div>
        </div>
        <div className={`${styles.chatDialPadInner} dialnumcon`}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold} dialnum`} onClick={() => onKeyPress("7")}>
            <span className="">7</span>
            <div className={styles.tooltips}>PQRS</div>
          </div>
        </div>
        <div className={`${styles.chatDialPadInner} dialnumcon`}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold} dialnum`} onClick={() => onKeyPress("8")}>
            <span className="">8</span>
            <div className={styles.tooltips}>TUV</div>
          </div>
        </div>
        <div className={`${styles.chatDialPadInner} dialnumcon`}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold} dialnum`} onClick={() => onKeyPress("9")}>
            <span className="">9</span>
            <div className={styles.tooltips}>WXYZ</div>
          </div>
        </div>
        <div className={`${styles.chatDialPadInner} dialnumcon`}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold} dialnum`} onClick={() => onKeyPress("*")}>
            <span className={styles.starNumber}>*</span>
            <div className={styles.tooltipsIcn}>,</div>
          </div>
        </div>
        <div className={`${styles.chatDialPadInner} dialnumcon`} onMouseDown={onmousedownfunc} onClick={onKeyUpPressed}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold} dialnum`}>
            <span className="">0</span>
            <div className={styles.tooltipsIcn}>+</div>
          </div>
        </div>
        <div className={`${styles.chatDialPadInner} dialnumcon`}>
          <div className={`${styles.chatDialPadNumber} ${styles.hold} dialnum`} onClick={() => onKeyPress("#")}>
            <span className="">#</span>
          </div>
        </div>
      </div>
      {isQueueList && callDetails?.length === 0 && (
        <div className={`${styles.chatDialCall} ${styles.chatdialnew} chatdialnew`}>
          {/* <WtButton className="makeCall" name="Make a call" onClick={makeCall} /> */}
          <Select
            getPopupContainer={(trigger: { parentNode: any }) => trigger.parentNode}
            value={queueDetails.value}
            onChange={(value: any, key: any) => {
              setError({
                ...error,
                queue: false
              });
              dispatch(CallPopUpAgentActions.setQueueName(key));
              setDisable(false)

            }}
            placeholder="Select queue"
            className="antSelect selectcloseicon"
            popupClassName="antSelectPopover tickrightremove "
            showArrow={true}
            optionFilterProp="children"
            suffixIcon={<svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
              <path d="M6.00009 5.90231C5.39759 5.90231 4.83209 5.66791 4.40679 5.24121L0.553286 1.37691C0.260786 1.08391 0.261786 0.609307 0.554786 0.316407C0.848686 0.024407 1.32379 0.0244068 1.61579 0.318407L5.46879 4.18271C5.75249 4.46591 6.24809 4.46591 6.53079 4.18271L10.3843 0.318407C10.6763 0.0245068 11.1514 0.024507 11.4453 0.316407C11.7383 0.609407 11.7392 1.08401 11.4468 1.37691L7.59329 5.24121C7.16799 5.66801 6.60219 5.90231 6.00009 5.90231Z" fill="#757676" />
            </svg>}
            filterOption={(input, option: any) => {
              return option.value?.toLowerCase().indexOf(input?.toLowerCase()) >= 0;
            }}
            options={filterQueueList.map((item: any) => {
              const agentD = users?.filter((res: any) => LoginCcaasUserDetails?.UserID === res?.UserID)
              if (agentD?.length > 0 && agentD[0]?.quId?.split(',')?.includes(`${item.qid}`)) {
                return (
                  {
                    key: item.qid,
                    value: item.name,
                    OutboundCallerId: item.OutboundCallerId,
                    outBoundNumber: item.outBoundNumber,
                  }
                )
              }
            })?.filter((d: any) => d)}
          ></Select>
        </div>
      )}
      {error?.queue ? <span  className={`${styles.invadidspancont} invalidspan`} >Queue is required</span> : <span  className={`${styles.invadidspancont} invalidspan`}></span>}
      {agentWithBound_call.map((user: any) => (
        user.UserID === LoginCcaasUserDetails.UserID && (
          <div className={`${styles.chatDialCall} chatdialcall `} key={user.UserID} >
            <WtButton id="CallBtn" disabled={(dialedNumber.length === 0 || disable) ? true : false} className="makeCall" name="Make a call" onClick={getContactDetail} />
          </div>)))}
      {agentWithoutBound_call.map((user: any) => (
        user.UserID === LoginCcaasUserDetails.UserID && (
          <div className={ `${styles.chatDialCall} chatdialcall `} key={user.UserID} >
            <WtButton id="CallBtn" disabled={dialedNumber.length === 0 ? true : false} className="makeCall" name="Make a call" onClick={noOutbound} />
          </div>)))}

    </>
  );
}
